import { CellProps } from "react-table";
import Status from "src/components/status/Status";
import TextCell from "src/components/tables/cells/TextCell";
import Tooltip from "src/components/tooltip/Tooltip";
import { LEAD_STATUS, LEAD_STATUS_CELL } from "src/utils/constants";
import ActionsCell from "./ActionsCell";
import { VendorType } from "./vendor-types";

const useVendorTableColumns = ({
  onDelete,
  onToggleProducts,
}: {
  onDelete: (id: number) => void;
  onToggleProducts: (id: number) => void;
}) => {
  return [
    {
      Header: "Vendor Name",
      accessor: "name",
      className: "min-w-[180px]",
      Cell: TextCell,
    },
    {
      Header: "Email",
      accessor: "email",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Phone",
      accessor: "phone",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Address",
      accessor: "address",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Business Type",
      accessor: "type",
      className: "min-w-[150px]",
      Cell: TextCell,
    },
    {
      Header: "Product View",
      accessor: "productView",
      className: "min-w-[150px]",
      Cell: ({ value, row: { original } }: CellProps<VendorType>) => (
        <Tooltip content={"Please select vender product"}>
          <div onClick={() => onToggleProducts(original.UserId)}>
            <TextCell
              value={"Product View"}
              className="text-[#0C8CE9] underline cursor-pointer"
            />
          </div>
        </Tooltip>
      ),
    },
    {
      Header: "Verification Status",
      accessor: "verifyStatus",
      className: "min-w-[150px]",
      Cell: ({ value }: CellProps<VendorType>) => {
        const status = LEAD_STATUS_CELL[value as LEAD_STATUS];
        return <Status {...status} />;
      },
    },
    {
      Header: "Actions",
      accessor: "id",
      className: "min-w-[200px]",
      Cell: ({ value }: CellProps<VendorType>) => (
        <ActionsCell value={value} onDelete={() => onDelete(value)} />
      ),
    },
  ];
};

export default useVendorTableColumns;
